import React, { type FC } from 'react'
import { Stack, type SxProps, type Theme, Typography } from '@mui/material'

import { isObjectEmpty } from '../../../utils'

import { type ConnectwareError, Translation } from '../../../domain'

import { FormattedTranslation } from '../Internationalization'
import { Button } from '../common/Button'
import { AnchoredPopover } from './AnchoredPopover'
import { errorMessagesClasses } from './Classes'
import { Extras, StackTrace } from './Code'

const contentStyle: SxProps<Theme> = { p: 2, gap: 1, maxWidth: 640 }

/** A "Details" button that opens a popover with the type, the stack trace and, if any, the extras of the error */
export const ErrorDetails: FC<Readonly<{ error: ConnectwareError }>> = ({ error }) => (
    <AnchoredPopover
        className={errorMessagesClasses['details-content']}
        trigger={({ open, onClick }) => (
            <Button
                data-testid="error-details-button"
                className={errorMessagesClasses['details-button']}
                variant="ghost"
                size="medium"
                aria-expanded={open}
                onClick={onClick}
            >
                <FormattedTranslation id={Translation.ERROR_DETAILS} />
            </Button>
        )}
    >
        <Stack sx={contentStyle}>
            <Typography className={errorMessagesClasses['details-type']} variant="body2">
                <FormattedTranslation id={Translation.ERROR_DETAILS_TYPE} values={{ type: error.type }} />
            </Typography>
            <StackTrace error={error} />
            {!isObjectEmpty(error.extras) && <Extras variant="body2" error={error} />}
        </Stack>
    </AnchoredPopover>
)
